import { createContext } from 'react';
import LocalizationContextState from './LocalizationContext.types';

export const LocalizationContext = createContext<LocalizationContextState>({
  language: 'en-GB',
  supportedLanguages: [{ language: 'en-GB', name: 'English' }],
  setLanguage: () => {},
});

export default LocalizationContext;
